var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#F5F6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.5002C22.4992 13.7048 22.1828 12.9422 21.6204 12.3798C21.058 11.8174 20.2954 11.501 19.5 11.5002H17.0125C16.8306 11.4896 13.6613 11.2665 10.6431 8.73522C10.4974 8.61281 10.3197 8.53454 10.131 8.5096C9.94236 8.48466 9.75047 8.51408 9.57793 8.59442C9.40538 8.67475 9.25935 8.80265 9.15697 8.9631C9.0546 9.12355 9.00014 9.30989 9 9.50022V19.5002C9.00003 19.6906 9.0544 19.877 9.15672 20.0376C9.25905 20.1981 9.40508 20.3261 9.57764 20.4065C9.75021 20.4869 9.94214 20.5164 10.1309 20.4915C10.3196 20.4666 10.4973 20.3883 10.6431 20.2658C13.0037 18.2858 15.4556 17.7183 16.5 17.5596V19.5421C16.4998 19.7069 16.5403 19.8692 16.6179 20.0145C16.6956 20.1599 16.8079 20.2838 16.945 20.3752L17.6325 20.8333C17.7654 20.922 17.9176 20.9776 18.0764 20.9954C18.2351 21.0132 18.3959 20.9926 18.5451 20.9355C18.6943 20.8784 18.8276 20.7864 18.934 20.6672C19.0403 20.5479 19.1165 20.405 19.1562 20.2502L19.8919 17.4777C20.6136 17.3817 21.2759 17.0269 21.7556 16.4792C22.2353 15.9315 22.4998 15.2283 22.5 14.5002ZM10 19.4958V9.50022C12.6756 11.7446 15.4144 12.3127 16.5 12.4527V16.5452C15.4156 16.6877 12.6775 17.2546 10 19.4958ZM18.1875 19.9958V20.0027L17.5 19.5446V17.5002H18.85L18.1875 19.9958ZM19.5 16.5002H17.5V12.5002H19.5C20.0304 12.5002 20.5391 12.7109 20.9142 13.086C21.2893 13.4611 21.5 13.9698 21.5 14.5002C21.5 15.0306 21.2893 15.5394 20.9142 15.9144C20.5391 16.2895 20.0304 16.5002 19.5 16.5002Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.3831adfe2770bc9e04e81cc4734553c8.svg";
export { ForwardRef as ReactComponent };